<template>
  <div class="key-access-page">
    <div class="card">
      <h2>密钥信息</h2>
      
      <div v-if="loading" class="loading">
        <p>加载中...</p>
      </div>
      
      <div v-else-if="error" class="error-message">
        <p>{{ error }}</p>
      </div>
      
      <div v-else-if="keyData" class="key-info">
        <div class="info-item">
          <label>好友名称:</label>
          <span>{{ keyData.friendName }}</span>
        </div>
        
        <div class="info-item">
          <label>密钥:</label>
          <div class="key-value">
            <span>{{ keyData.key }}</span>
            <button class="btn btn-copy" @click="copyText(keyData.key)">复制</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cryptoUtil from '../utils/crypto.js'
import { CRYPTO_CONFIG } from '../utils/config.js'

export default {
  name: 'KeyAccessPage',
  data() {
    return {
      keyData: null,
      loading: true,
      error: null
    }
  },
  mounted() {
    this.loadKeyData()
  },
  methods: {
    loadKeyData() {
      this.loading = true
      this.error = null
      
      try {
        // 从URL参数中获取加密的数据
        const encryptedData = this.$route.params.id
        if (!encryptedData) {
          throw new Error('未提供密钥数据')
        }
        
        console.log('加密数据:', encryptedData)
        
        // 处理可能的URL编码问题
        let processedEncryptedData = encryptedData
        try {
          // 如果数据被意外URL编码，尝试解码
          if (encryptedData.includes('%')) {
            const decoded = decodeURIComponent(encryptedData)
            console.log('URL解码后的数据:', decoded)
            processedEncryptedData = decoded
          }
        } catch (e) {
          console.warn('URL解码失败，使用原始数据:', e)
        }
        
        // 使用配置中的密钥解密数据
        const encryptionKey = CRYPTO_CONFIG.ENCRYPTION_KEY;
        const decodedData = cryptoUtil.decrypt(processedEncryptedData, encryptionKey)
        console.log('解密后的数据:', decodedData)
        
        // 确保解密后的数据是有效的JSON
        let trimmedData = decodedData.trim()
        console.log('修整后的数据:', trimmedData)
        
        // 尝试解析JSON
        const keyData = JSON.parse(trimmedData)
        console.log('解析后的数据:', keyData)
        
        this.keyData = keyData
        this.loading = false
      } catch (error) {
        console.error('解析密钥数据失败:', error)
        
        // 提供更详细的错误信息
        let errorMessage = '无法解析密钥数据，请确保链接正确'
        
        // 根据错误类型提供具体信息
        if (error instanceof SyntaxError) {
          errorMessage += ': JSON格式错误 - ' + error.message
        } else if (error.message.includes('密文和密钥不能为空')) {
          errorMessage = '链接中缺少必要的加密数据'
        } else {
          errorMessage += ': ' + error.message
        }
        
        this.error = errorMessage
        this.loading = false
      }
    },
    
    copyText(text) {
      navigator.clipboard.writeText(text)
        .then(() => {
          alert('密钥已复制到剪贴板')
        })
        .catch(err => {
          console.error('复制失败:', err)
          alert('复制失败，请手动复制')
        })
    }
  }
}
</script>

<style scoped>
.key-access-page {
  display: flex;
  justify-content: center;
  padding: 20px;
}

.card {
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 30px;
  width: 100%;
  max-width: 600px;
}

h2 {
  color: #07C160;
  margin-bottom: 30px;
  text-align: center;
}

.loading {
  text-align: center;
  padding: 40px 0;
  color: #666;
}

.error-message {
  color: #ff4d4f;
  text-align: center;
  padding: 20px 0;
}

.key-info {
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
}

.info-item {
  margin-bottom: 20px;
}

.info-item:last-child {
  margin-bottom: 0;
}

.info-item label {
  display: block;
  font-weight: bold;
  margin-bottom: 8px;
  color: #333;
}

.key-value {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
}

.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-copy {
  background-color: #07C160;
  color: white;
}
</style>